module.exports = "<div class=\"drx-container\">\r\n  <drx-admin-topbar></drx-admin-topbar>\r\n  <div class=\"main-container\">\r\n    <div class=\"drx-sidebar\" [ngClass]=\"{'drx-sidebar-toggle' : toggleCollapse}\">\r\n      <drx-sidebar (onToggleSidebar)=\"toggleSidebar($event)\"></drx-sidebar>\r\n    </div>\r\n    <div class=\"drx-main\">\r\n      <main class=\"main-content\">\r\n        <router-outlet></router-outlet>\r\n      </main>\r\n    </div>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/admin/admin.component.html
// module id = ./src/app/components/admin/admin.component.html
// module chunks = main